/* global */

import $ from 'jquery'
import { foundation } from 'foundation-sites/js/foundation.core'
import 'foundation-sites/js/foundation.util.mediaQuery'
import 'foundation-sites/js/foundation.reveal'
import 'foundation-sites/js/foundation.util.motion'
import 'foundation-sites/js/foundation.util.keyboard'
import 'foundation-icons/foundation-icons.css'
$.fn.foundation = foundation

import Vue from 'vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import VueBreadcrumbs from './components/services/breadcrumbs'
import VueLayout from './components/services/layout'
import addInterceptors from './components/interceptors'
import './components/foundation-directives'
import App from './components/App'

import routes from './components/routes'
import store from './components/store'

Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VueBreadcrumbs)
Vue.use(VueLayout)

addInterceptors(Vue.http)

export var router = new VueRouter({routes})

export var app = new Vue({
  router,
  el: '#app',
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js